import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useFetch } from 'src/consumer/services'

export const PAGE_VIEW_STATES = {
  choosePaymentGateway: 'choosePaymentGateway',
  successConfirmation: 'successConfirmation',
}

export default function PackBuying() {
  // const navigate = useNavigate()
  // const dispatch = useDispatch()
  // const { mentorSlug, packId } = useParams()
  // const token = localStorage.getItem('token')

  // const [pageView, setPageView] = useState(PAGE_VIEW_STATES.choosePaymentGateway)
  // const {
  //   loading: professionalDataLoading,
  //   data: professionalData,
  //   error: professionalDataError,
  // } = useFetch(
  //   '/api/service-provider',
  //   `&id=${mentorSlug}&slug=${mentorSlug}&zoneOffset=${encodeURIComponent(
  //     getTimezoneOffset(),
  //   )}&appVersion=${appVersion}&platformType=${platformWeb}`,
  //   'web',
  // )
  // const [thisBundlePlanData, setThisBundlePlanData] = useState()
  // const [userProfileData, setUserProfileData] = useState()
  // const mentorId = professionalData?.id

  // // stripe states:
  // const [stripePromise, setStripePromise] = useState(null)

  // function clickPaymentGateway(clickedPaymentGateway) {
  //   if (token) {
  //     console.log(clickedPaymentGateway)
  //   } else {
  //     setShowClubbedAuthModal(true)
  //     setTypeOfClubbedAuthModal('login')
  //   }
  // }

  // useEffect(() => {
  //   ;(async () => {
  //     if (!professionalDataLoading && Boolean(professionalData)) {
  //       const respData = await getBookingPlanData(professionalData?.eventTypes, eventId)
  //       const respBundleData = await getBundlesDataFromBundlesArray(
  //         professionalData?.eventTypes,
  //         eventId,
  //       )
  //       setPlanData(respData)
  //       setBundlesData(respBundleData)
  //     }
  //   })()
  // }, [professionalDataLoading, professionalData]) // setting plan data

  // useEffect(() => {
  //   ;(async () => {
  //     const resp = await getData('/api/secure/user/profile')
  //     if (resp?.status === 200) {
  //       setUserProfileData(resp?.data)
  //     }
  //   })()
  // }, []) // user profile data

  // useEffect(() => {
  //   loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY).then((result) => {
  //     setStripePromise(result)
  //   })
  // }, []) // making stripe promise

  // useEffect(() => {
  //   ;(async () => {
  //     if (professionalData) {
  //       setCalendarLoading(true)
  //       const response = await createAvailableTimeSlotsArray(
  //         lastActiveStartDate,
  //         selectedTimeZone,
  //         scheduleOfProfessional?.timeZone,
  //         scheduleOfProfessional,
  //         eventDetailOfRequestedEvent,
  //         mentorId,
  //         eventId,
  //         selectedTimeZone,
  //         false,
  //       )
  //       setCalendarLoading(false)
  //       setAvailableTimeSlots(response)
  //     }
  //   })()
  // }, [selectedTimeZone, professionalData]) // updating calendar data everytime timezone changes or professionaldata changes

  // async function onSuccessfulBuyingBundle() {
  //   if (
  //     bundleBuyingWaitingState?.bundleBuy === 'success' &&
  //     bundleBuyingWaitingState?.eventBooking === null
  //   ) {
  //     // setPageView(PAGE_VIEW_STATES.bookingConfirmation)
  //     navigate('/event-booking-successful', {
  //       state: {
  //         eventDetailOfRequestedEvent,
  //         chosenSlotData,
  //         fromOnboarding,
  //         professionalData,
  //         openedAsWebview,
  //         bundleBuyingWaitingState,
  //       },
  //     })

  //     // initiate booking using the credit here
  //     setBundleBuyingWaitingState({ bundleBuy: 'success', eventBooking: 'waiting' })
  //     await payAndMakeEventBooking(
  //       eventDetailOfRequestedEvent, // bookingEventDetails
  //       chosenSlotData, // chosenSlotData
  //       'credits', // paymentGateway
  //       'GFT-DEFAULT', //  giftCardId
  //       stripePromise, // stripePromise
  //       mentorId, // mentorId
  //       userProfileData, // userProfileData
  //       setGiftCodeError, // giftCodeErrorSetter
  //       () => {
  //         setBundleBuyingWaitingState({ bundleBuy: 'success', eventBooking: 'success' })
  //         getAndSetUserCreditsInStore()
  //       }, // afterConfirmationFunction
  //       'uid', // eventIdField
  //       'regular', // bookingType
  //       () => null, // orderCreationDataSetter
  //       [addictionFormData],
  //     )
  //   }
  // }

  // useEffect(() => {
  //   onSuccessfulBuyingBundle()
  // }, [bundleBuyingWaitingState])

  // const handleMonthChange = async (action, activeStartDate, value, view) => {
  //   if (
  //     (action === 'prev' && view === 'month') ||
  //     (action === 'prev2' && view === 'month') ||
  //     (action === 'next' && view === 'month') ||
  //     (action === 'next2' && view === 'month') ||
  //     (action === 'drillDown' && view === 'month')
  //   ) {
  //     setLastActiveStartDate(dayjs(activeStartDate)?.format('YYYY-MM-DD'))
  //     const activeStartDateBasicFormat = dayjs(activeStartDate)?.format('YYYY-MM-DD')
  //     setCalendarLoading(true)
  //     const response = await createAvailableTimeSlotsArray(
  //       activeStartDateBasicFormat,
  //       selectedTimeZone,
  //       scheduleOfProfessional?.timeZone,
  //       scheduleOfProfessional,
  //       eventDetailOfRequestedEvent,
  //       mentorId,
  //       eventId,
  //       selectedTimeZone,
  //       true,
  //     )
  //     setAvailableTimeSlots(response)
  //     setCalendarLoading(false)
  //   }
  //   setSelectedDateValue(null)
  // } // function to handle when month is changed, getting all available time slots

  // function onChangeDate(nextValue) {
  //   setSelectedTimeSlotIndex()
  //   setSelectedDateValue(nextValue)
  // } // change date function for calendar

  // useEffect(() => {
  //   if (window.innerWidth < 660) {
  //     const timeSlotChoosingContainer = document.getElementById('timeSlotChoosingContainer')
  //     if (timeSlotChoosingContainer) {
  //       timeSlotChoosingContainer.scrollIntoView({
  //         behavior: 'smooth', // Use smooth scrolling behavior
  //       })
  //     }
  //   }
  // }, [selectedDateValue])

  // useEffect(() => {
  //   if (cameFromDeAddictionPlanPage) {
  //     setPageView(PAGE_VIEW_STATES.next_few_slots)
  //   }
  // }, [cameFromDeAddictionPlanPage])

  // if (professionalDataLoading) {
  //   return <LoadingSpinner bgColor="#F5F5F599" dark />
  // } // loader if secure setup data is coming

  // if (
  //   !Boolean(mentorId) ||
  //   !Boolean(eventId) ||
  //   mentorId === 'undefined' ||
  //   mentorId === 'null' ||
  //   eventId === 'null' ||
  //   eventId === 'undefined' ||
  //   !Boolean(mentorSlug) ||
  //   mentorSlug === 'undefined' ||
  //   mentorSlug === 'null' ||
  //   !professionalData?.eventTypes?.some((item) => item?.uid === eventId)
  // ) {
  //   return (
  //     <>
  //       <PublicAppHeader config={{ showLinks: true }} />
  //       <div>
  //         ⚠️ Invalid Request, Please try again or choose another professional. If you are still
  //         unable to book session, please write to us here
  //       </div>
  //       <div>📨{APP_CONSTANTS.SUPPORT_EMAIL}</div>
  //     </>
  //   )
  // } // handling cases when url is not valid

  // const dateToday = new Date()
  // const maxDate = new Date(dateToday)
  // maxDate?.setMonth(dateToday?.getMonth() + 2) // setting max date of calendar

  // async function confirmBundleAndMoveToNextPage() {
  //   setPageView(PAGE_VIEW_STATES.confirm_slot_choose_payment)
  // }

  // function showBookingConfirmationPage() {
  //   // setPageView(PAGE_VIEW_STATES.bookingConfirmation)
  //   navigate('/event-booking-successful', {
  //     state: {
  //       eventDetailOfRequestedEvent,
  //       chosenSlotData,
  //       fromOnboarding,
  //       professionalData,
  //       openedAsWebview,
  //       bundleBuyingWaitingState,
  //     },
  //   })
  // }

  // async function payAndMakeBooking(paymentGateway, giftCardId) {
  //   setConfirmBookingLoading(true)
  //   await payForTheBundle(
  //     chosenPurchaseTypeId, // chosenBundleId
  //     stripePromise, // stripePromise
  //     paymentGateway, // paymentGateway
  //     setBundleBuyingWaitingState,
  //   )
  //   setConfirmBookingLoading(false)
  // }

  // function handleGoBack() {
  //   window.history.back()
  // }

  // return (
  //   <>
  //     {sessionStorage.getItem('isThisWebviewSession') || openedAsWebview ? (
  //       <div
  //         style={{
  //           padding: '10px 20px',
  //           position: 'fixed',
  //           top: 0,
  //           background: '#fff',
  //           width: '100%',
  //         }}
  //       >
  //         {sessionStorage.getItem('isThisWebviewSession') && (
  //           <IconButton onClick={handleGoBack}>
  //             <KeyboardBackspaceIcon sx={{ fontSize: 28, color: 'black', marginRight: '5px' }} />
  //           </IconButton>
  //         )}
  //       </div>
  //     ) : (
  //       <PublicAppHeader
  //         config={{ showLinks: false, showBackButton: window.history.length > 2 }}
  //         backButtonFunction={handleGoBack}
  //       />
  //     )}
  //     <EventBookingPageBackground>
  //       <EventBookingInteractionPage dontMakeItARow={cameFromDeAddictionPlanPage}>
  //         {pageView !== PAGE_VIEW_STATES.bookingConfirmation &&
  //           pageView !== PAGE_VIEW_STATES.bundleSelection && (
  //             <MentorDetailSection
  //               bookingEvent={eventDetailOfRequestedEvent}
  //               chosenSlotData={chosenSlotData}
  //               pageView={pageView}
  //               planData={planData}
  //               bundlesData={bundlesData}
  //               chosenPurchaseTypeId={chosenPurchaseTypeId}
  //               professionalData={professionalData}
  //               isMountedOnAWebView={isMountedOnAWebView}
  //               rateText={eventBookingPageStrings?.rate || 'Rate'}
  //               showMentorDetails={!cameFromDeAddictionPlanPage}
  //               isNotInARow={cameFromDeAddictionPlanPage}
  //             />
  //           )}

  //         {pageView === PAGE_VIEW_STATES.bundleSelection && (
  //           <div style={{ width: '100%', height: '100%' }}>
  //             <GenericDisplayFlexColumn style={{ alignItems: 'center', gap: '40px' }}>
  //               <SubheadingPaymentsPage
  //                 style={{ cursor: 'pointer' }}
  //                 onClick={() => {
  //                   setPageView(PAGE_VIEW_STATES.calendar_view)
  //                   setChosenPurchaseTypeId('single')
  //                 }}
  //               >
  //                 <KeyboardBackspaceIcon
  //                   sx={{ fontSize: 15, color: 'black', marginRight: '5px' }}
  //                 />
  //                 Back to Calendar
  //               </SubheadingPaymentsPage>
  //               <div style={{ fontSize: '18px', fontWeight: '500' }}>Want a bundle?</div>
  //               <EBBundleItemsContainer>
  //                 <EBBundleItem
  //                   title="This Session Only"
  //                   currencySymbol={planData?.currency}
  //                   price={planData?.price}
  //                   discountedPrice={planData?.finalPrice}
  //                   themeColor={colorsArray[0]}
  //                   clickFunction={() => {
  //                     setChosenPurchaseTypeId('single')
  //                     confirmBundleAndMoveToNextPage()
  //                   }}
  //                 />
  //                 {bundlesData?.map((bundleItem, bundleItemIndex) => {
  //                   console.log(bundleItem)
  //                   return (
  //                     <EBBundleItem
  //                       key={bundleItemIndex}
  //                       title={bundleItem?.title}
  //                       currencySymbol={bundleItem?.currency}
  //                       price={bundleItem?.price}
  //                       themeColor={colorsArray[bundleItemIndex + 1]}
  //                       discountedPrice={bundleItem?.finalPrice}
  //                       bundle={bundleItem?.bundle}
  //                       clickFunction={() => {
  //                         setChosenPurchaseTypeId(bundleItem?.id)
  //                         confirmBundleAndMoveToNextPage()
  //                       }}
  //                     />
  //                   )
  //                 })}
  //               </EBBundleItemsContainer>
  //             </GenericDisplayFlexColumn>
  //           </div>
  //         )}

  //         {pageView === PAGE_VIEW_STATES.next_few_slots && (
  //           <NextAvailableSlots
  //             availableTimeSlots={availableTimeSlots}
  //             dateUnavailableChecker={tileDisabled}
  //             eventBookingPageStrings={eventBookingPageStrings}
  //             loading={calendarLoading}
  //             userProfileData={userProfileData}
  //             onClick={(timeSlot) => {
  //               confirmDateAndTime(
  //                 timeSlot,
  //                 eventDetailOfRequestedEvent.preBufferMins,
  //                 eventDetailOfRequestedEvent.postBufferMins,
  //               )
  //               setSelectedDateValue(dayjs(timeSlot?.startTime).format('YYYY-MM-DD'))
  //             }}
  //             onClickSeeMore={() => setPageView(PAGE_VIEW_STATES.calendar_view)}
  //             handleMonthChange={handleMonthChange}
  //           />
  //         )}

  //         {pageView === PAGE_VIEW_STATES.calendar_view && (
  //           <GenericDisplayFlexColumn>
  //             <SelectDateHeading isNotInARow={cameFromDeAddictionPlanPage}>
  //               {eventBookingPageStrings?.select_date_and_time_in_calendar ||
  //                 'Select a Date & Time '}
  //               {calendarLoading && (
  //                 <Spinner
  //                   animation="border"
  //                   variant="dark"
  //                   size="sm"
  //                   style={{ margin: '0 auto' }}
  //                 />
  //               )}
  //             </SelectDateHeading>
  //             {userProfileData && (
  //               <div style={{ display: 'flex', gap: '5px' }}>
  //                 <SignedInUserName noPadding={cameFromDeAddictionPlanPage}>
  //                   {eventBookingPageStrings?.signed_in_as || 'Signed in as'}
  //                 </SignedInUserName>
  //                 <SignedInUserName main noPadding>
  //                   {' '}
  //                   {userProfileData?.name}.
  //                 </SignedInUserName>
  //                 {!isMountedOnAWebView && (
  //                   <SignedInUserName
  //                     main
  //                     noPadding
  //                     style={{ cursor: 'pointer' }}
  //                     onClick={() => {
  //                       logoutHandler()
  //                       navigate('/login')
  //                     }}
  //                   >
  //                     {' '}
  //                     {eventBookingPageStrings?.logout || 'Logout'}?
  //                   </SignedInUserName>
  //                 )}
  //               </div>
  //             )}
  //             <CalendarPartContainer
  //               noMargin={cameFromDeAddictionPlanPage}
  //               noPadding={cameFromDeAddictionPlanPage}
  //             >
  //               <CalendarContainer>
  //                 <Calendar
  //                   onChange={onChangeDate}
  //                   value={selectedDateValue}
  //                   minDate={dateToday}
  //                   maxDate={maxDate}
  //                   minDetail="decade"
  //                   tileDisabled={tileDisabled}
  //                   showNeighboringMonth={false}
  //                   locale={sessionStorage.getItem('languageCode') || 'en'}
  //                   onActiveStartDateChange={({ action, activeStartDate, value, view }) =>
  //                     handleMonthChange(action, activeStartDate, value, view)
  //                   }
  //                 />
  //                 <StyledSelectTimeZone
  //                   value={selectedTimeZone}
  //                   onChange={(e) => setSelectedTimeZone(e.target.value)}
  //                 >
  //                   {getTimeZoneOptionsWithValueAsTimezoneOffset()}
  //                 </StyledSelectTimeZone>
  //               </CalendarContainer>

  //               <TimeChoosingContainer
  //                 selectedDateValue={selectedDateValue}
  //                 id="timeSlotChoosingContainer"
  //               >
  //                 <TimeChoosingContainerHeading>
  //                   {dayjs(selectedDateValue)?.format('ddd, MMM D')}
  //                 </TimeChoosingContainerHeading>

  //                 <AnimatedContainerTimeSlots key={selectedDateValue}>
  //                   {availableTimeSlots
  //                     ?.find(
  //                       (item) => item?.date === dayjs(selectedDateValue)?.format('YYYY-MM-DD'),
  //                     )
  //                     ?.availableTimeSlots?.map((timeSlotItem, index) => {
  //                       return (
  //                         <GenericDisplayFlex style={{ gap: '5px' }} key={index}>
  //                           <TimeButton onClick={() => setSelectedTimeSlotIndex(index)}>
  //                             {adjustPrebufferTimeAndConvertAMPM(
  //                               timeSlotItem?.startTime?.substring(11, 16),
  //                               eventDetailOfRequestedEvent?.preBufferMins,
  //                             )}
  //                           </TimeButton>
  //                           {selectedTimeSlotIndex === index && (
  //                             <TimeButton
  //                               confirm
  //                               onClick={() =>
  //                                 confirmDateAndTime(
  //                                   timeSlotItem,
  //                                   eventDetailOfRequestedEvent?.preBufferMins,
  //                                   eventDetailOfRequestedEvent?.postBufferMins,
  //                                 )
  //                               }
  //                             >
  //                               {eventBookingPageStrings?.confirm || 'Confirm'}
  //                             </TimeButton>
  //                           )}
  //                         </GenericDisplayFlex>
  //                       )
  //                     })}
  //                 </AnimatedContainerTimeSlots>
  //               </TimeChoosingContainer>
  //             </CalendarPartContainer>
  //           </GenericDisplayFlexColumn>
  //         )}

  //         {pageView === PAGE_VIEW_STATES.confirm_slot_choose_payment && (
  //           <ConfirmSlotChoosePaymentComponent
  //             bookingEvent={eventDetailOfRequestedEvent}
  //             chosenSlotData={chosenSlotData}
  //             confirmBookingLoading={confirmBookingLoading}
  //             payAndMakeBooking={payAndMakeBooking}
  //             paymentMethodChosen={paymentMethodChosen}
  //             planData={planData}
  //             bundlesData={bundlesData}
  //             chosenPurchaseTypeId={chosenPurchaseTypeId}
  //             setChosenSlotData={setChosenSlotData}
  //             setPageView={setPageView}
  //             userProfileData={userProfileData}
  //             setPaymentMethodChosen={setPaymentMethodChosen}
  //             isWebview={Boolean(sessionStorage.getItem('isThisWebviewSession') || openedAsWebview)}
  //             goBackToCalendarButtonFunction={goBackFromPaymentMethods}
  //           />
  //         )}

  //         {pageView === PAGE_VIEW_STATES.payUsingGiftCard && (
  //           <PayUsingGiftCardComponent
  //             confirmBookingLoading={confirmBookingLoading}
  //             giftCode={giftCode}
  //             setGiftCode={setGiftCode}
  //             giftCodeError={giftCodeError}
  //             setGiftCodeError={setGiftCodeError}
  //             payAndMakeBooking={payAndMakeBooking}
  //             paymentMethodChosen={paymentMethodChosen}
  //             setPageView={setPageView}
  //           />
  //         )}

  //         {pageView === PAGE_VIEW_STATES.bookingConfirmation && (
  //           <PaymentConfirmationComponent
  //             bookingEventDetails={eventDetailOfRequestedEvent}
  //             chosenSlotData={chosenSlotData}
  //             fromOnboarding={fromOnboarding}
  //             professionalData={professionalData}
  //             hideHomeButton={sessionStorage.getItem('isThisWebviewSession') || openedAsWebview}
  //             bundleBuyingWaitingState={bundleBuyingWaitingState}
  //             isWebview={sessionStorage.getItem('isThisWebviewSession') || openedAsWebview}
  //           />
  //         )}
  //       </EventBookingInteractionPage>
  //       <ProfessionalText style={{ cursor: 'pointer' }} onClick={() => setFaqOpen(true)}>
  //         {eventBookingPageStrings?.have_questions || 'Have Questions'}?
  //       </ProfessionalText>
  //     </EventBookingPageBackground>

  //     {professionalData && eventDetailOfRequestedEvent?.title && (
  //       <SEOComponent
  //         title={`Book ${eventDetailOfRequestedEvent?.title} with ${professionalData?.name} | AUMHUM`}
  //         description={`${
  //           platformOptions?.find((item) => item?.id === eventDetailOfRequestedEvent?.meetingSrc)
  //             ?.name
  //         } ${typeName} with ${professionalData?.name}`}
  //         image={
  //           professionalData?.heroCardImage
  //             ? getImageLink(professionalData?.heroCardImage)
  //             : APP_CONSTANTS.APP_LOGO_LINK
  //         }
  //         keywordsArr={['mentor', 'online', 'job']}
  //       />
  //     )}

  //     <AppFAQModalComponent
  //       categories={[FAQ_CATEGORIES.event_booking_faqs]}
  //       open={faqOpen}
  //       onClose={() => setFaqOpen(false)}
  //     />

  //     {sessionStorage.getItem('isThisWebviewSession') || openedAsWebview ? (
  //       <></>
  //     ) : (
  //       <PublicAppFooter />
  //     )}
  //   </>
  // )
  return <></>
}
